"use client";

import Button from "@/components/Elements/Button";
import { useEffect, useRef } from "react";
import toast from "react-hot-toast";
import { heartbeat } from "@/actions/server";

const DeploymentDetection = () => {
  const hasNotified = useRef(false);

  // useEffect(() => {
  //   const check = async () => {
  //     console.log("Checking for deployment update...");
  //     if (hasNotified.current) return;
  //     try {
  //       await heartbeat();
  //       console.log("Heartbeat successful");
  //     } catch {
  //       console.log("Heartbeat failed");
  //       hasNotified.current = true;
  //       toast(
  //         <div className="flex flex-col gap-4 text-center md:text-left md:flex-row items-center space-x-4 text-base md:text-lg">
  //           <span>Sidan har uppdaterats med en ny version. Vänligen ladda om sidan.</span>
  //           <Button
  //             bgColor="white"
  //             textColor="black"
  //             borderColor="white"
  //             onClick={() => window.location.reload()}
  //           >
  //             Ladda om sidan
  //           </Button>
  //         </div>,
  //         {
  //           style: {
  //             background: "#1a5c99",
  //             color: "#fff",
  //             padding: "16px",
  //             bottom: "0px",
  //             border: "none",
  //             width: "100%",
  //           },
  //           id: "deployment-update-toast",
  //           duration: Infinity,
  //           position: "bottom-center",
  //         }
  //       );
  //     }
  //   };

  //   const id = setInterval(check, 5000); // Check each minute
  //   return () => clearInterval(id);
  // }, []);

  return null;
};

export default DeploymentDetection;
